"use strict";

require("./noConflict");

function _global() {
  const data = _interopRequireDefault(require("core-js/library/fn/global"));

  _global = function () {
    return data;
  };

  return data;
}

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (_global().default._babelPolyfill && typeof console !== "undefined" && console.warn) {
  console.warn("@babel/polyfill is loaded more than once on this page. This is probably not desirable/intended " + "and may have consequences if different versions of the polyfills are applied sequentially. " + "If you do need to load the polyfill more than once, use @babel/polyfill/noConflict " + "instead to bypass the warning.");
}

_global().default._babelPolyfill = true;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/polyfill/lib/index.js
// module id = 1001
// module chunks = 0